import ErrorState from "components/Error/ErrorState";
import LoadingIcon from "components/Loading/LoadingIcon";
import Notes from "components/Notes";
import { claimToNotesEntity } from "components/Notes/notesAdapter";
import { useParams } from "react-router-dom";
import { useGetClaimByIdQuery } from "services/claims-api";

import ClaimsPageContainer from "./ClaimsPageContainer";

const ClaimNotes = () => {
  const { claimId } = useParams<{ claimId: string }>();

  const {
    data: claim,
    isLoading,
    error,
  } = useGetClaimByIdQuery({ id: claimId }, { skip: !claimId });

  if (isLoading) {
    return (
      <ClaimsPageContainer>
        <LoadingIcon />
      </ClaimsPageContainer>
    );
  }

  if (error || !claim) {
    return (
      <ClaimsPageContainer>
        <ErrorState description="Failed to load claim data" />
      </ClaimsPageContainer>
    );
  }

  const notesEntity = claimToNotesEntity(claim);

  if (!notesEntity) {
    return (
      <ClaimsPageContainer>
        <ErrorState description="Unable to create notes context for this claim" />
      </ClaimsPageContainer>
    );
  }

  return (
    <ClaimsPageContainer>
      <Notes entity={notesEntity} />
    </ClaimsPageContainer>
  );
};

export default ClaimNotes;
